var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5207 13.9547H5.60559C5.19297 13.9547 4.85879 14.2894 4.85879 14.7021C4.85879 15.1148 5.19297 15.4495 5.60559 15.4495H9.5207C9.93331 15.4495 10.2675 15.1148 10.2675 14.7021C10.2675 14.2894 9.93331 13.9547 9.5207 13.9547Z",
    fill: "#434343",
    stroke: "#434343",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60559 11.0149H13.537C13.9496 11.0149 14.2838 10.6802 14.2838 10.2675C14.2838 9.85488 13.9496 9.52017 13.537 9.52017H5.60559C5.19297 9.52017 4.85879 9.85488 4.85879 10.2675C4.85879 10.6802 5.19297 11.0149 5.60559 11.0149Z",
    fill: "#434343",
    stroke: "#434343",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60559 6.86012H13.5552C13.9678 6.86012 14.302 6.52541 14.302 6.11275C14.302 5.70009 13.9678 5.36538 13.5552 5.36538H5.60559C5.19297 5.36538 4.85879 5.70009 4.85879 6.11275C4.85879 6.52541 5.19297 6.86012 5.60559 6.86012Z",
    fill: "#434343",
    stroke: "#434343",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.151 18.8504L13.1507 18.8497C12.9413 18.4974 12.7852 18.111 12.6956 17.6997L12.6956 17.6997L12.695 17.6971C12.6748 17.6117 12.6589 17.523 12.6449 17.4323C12.615 17.2248 12.6012 17.0195 12.6012 16.8236C12.6012 14.8198 14.0716 13.1517 15.9885 12.8427C16.1989 12.8104 16.4107 12.792 16.6288 12.792C16.8011 12.792 16.9715 12.8035 17.1402 12.8243C19.1213 13.0755 20.6564 14.7734 20.6564 16.8236C20.6564 19.0467 18.8495 20.8552 16.6288 20.8552C15.1731 20.8552 13.8581 20.0538 13.151 18.8504ZM17.3087 11.3393V4.00879C17.3087 2.92967 16.4301 2.04995 15.3516 2.04995H3.80711C2.72868 2.04995 1.85 2.92967 1.85 4.00879V17.1175C1.85 18.1966 2.72868 19.0764 3.80711 19.0764H11.5893C12.4617 21.0139 14.4241 22.35 16.6288 22.35C19.6743 22.35 22.15 19.8692 22.15 16.8236C22.15 14.006 20.0341 11.6761 17.3087 11.3393ZM3.80711 17.5816C3.55111 17.5816 3.3436 17.3741 3.3436 17.1175V4.00879C3.3436 3.7522 3.55111 3.54469 3.80711 3.54469H15.3516C15.6076 3.54469 15.8151 3.7522 15.8151 4.00879V11.3592C13.1548 11.751 11.1076 14.0519 11.1076 16.8236C11.1076 17.0675 11.1242 17.3214 11.1592 17.5816H3.80711Z",
    fill: "#434343",
    stroke: "#434343",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7095 16.3072H17.2284V14.8244C17.2284 14.4118 16.8942 14.0771 16.4816 14.0771C16.0689 14.0771 15.7348 14.4118 15.7348 14.8244V17.0545C15.7348 17.4672 16.0689 17.8019 16.4816 17.8019H18.7095C19.1222 17.8019 19.4563 17.4672 19.4563 17.0545C19.4563 16.6419 19.1222 16.3072 18.7095 16.3072Z",
    fill: "#434343",
    stroke: "#434343",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestHistory);
export default __webpack_public_path__ + "static/media/testHistory.31183909f4171b852a4bc4a036007cfd.svg";
export { ForwardRef as ReactComponent };